import { keyframes } from "@emotion/react";
import { useEffect, useState } from "react"

export const useCarouselTextAnimation = (width, maxWidth) => {
    const defaultAnimationTime = 10;
    const [animationTime, setAnimationTime] = useState(defaultAnimationTime);
    const [stopTimePercentage, setStopTimePercentage] = useState(0);

    useEffect(() => {
        const defaultWidthRatio = 1.5;
        const animationStopTime = 0.5;

        if(width <= maxWidth)
        {
            setAnimationTime(0);
            setStopTimePercentage(0);
            return;
        }

        const widthRatio = width / maxWidth;

        const newAnimationTime = Math.round((defaultAnimationTime * widthRatio) / defaultWidthRatio);

        setAnimationTime(newAnimationTime);

        const newStopTimePercentage = (animationStopTime * 100) / newAnimationTime;

        setStopTimePercentage(newStopTimePercentage);
    }, [width, maxWidth]);

    if(animationTime === 0)
    {
        return undefined;
    }

    const leftPosition = {
        transform: 'translate(0, 0)',
        left: '0%'
    }

    const rightPosition = {
        transform: 'translate(-100%, 0)',
        left: '100%'
    }

    const move = keyframes({
        [`${stopTimePercentage}%`]: leftPosition,
        '50%': rightPosition,
        [`${50 + stopTimePercentage}%`]: rightPosition,
        '100%': leftPosition
    });

    return `${move} ${animationTime}s ease-in-out infinite`;
}